import RevolverWinTransitions from "./revolver-win-transitions";
import Contract from "slotworks/utils/contract";
import Layers from "slotworks/graphics/layers/layers";
import { FadeIn, PivotBounceZoomOut, FadeOut } from "slotworks/graphics/animation/base-animations";
import { parallel, sequence } from "slotworks/utils/race-utils";
import * as TweenJS from "slotworks/utils/tween";
import Timer from "slotworks/utils/timer";
import gameState from "slotworks/model/game-state";
import Components from "slotworks/components/components";
import soundManager from "slotworks/sound/sound-manager";
import G288Components from "components/components";

export default class BigWinTransitions extends RevolverWinTransitions {

    private letters: PIXI.Sprite[] = [];

    public in(): Contract<void> {
        return new Contract((resolve) => {
            this.resetEverything();
            RevolverWinTransitions.winValue.visible = false;
            RevolverWinTransitions.winGlow.visible = false;
            this.inResolve = resolve;
            RevolverWinTransitions.background.visible = true;
            FadeIn(RevolverWinTransitions.background, this.BOUNCE_TIME).execute();

            this.letters = [...Layers.CelebrationContent.container.children] as PIXI.Sprite[];

            RevolverWinTransitions.currentTiers = this.getSelectedTiers().length;
            let wintype = [
                'big',
                'mega',
                'supermega',
                'epic'
            ];
            this.setLettersAnchors(this.letters);
            this.zoomInStacks(450, 1, 300).execute();
            this.timers.push(Timer.setTimeout(() => {
                this.zoomInLetters(this.letters, RevolverWinTransitions.currentTiers == 1);
                RevolverWinTransitions.winGlow.visible = true;
                this.fadeIn(RevolverWinTransitions.winGlow, 400, 0.8);
                RevolverWinTransitions.coins.emit = true;
                RevolverWinTransitions.coins.frequency = 0.2;
                RevolverWinTransitions.winValue.visible = true;
                soundManager.customEvent(`${wintype[RevolverWinTransitions.currentTiers - 1]}_win`);                
                this.zoomTextIn(1.1, 1, 200).then(() => {                          
                    if(RevolverWinTransitions.currentTiers > 1) {  
                        this.timers.push(Timer.setTimeout(() => { 
                            this.zoomOutLetters(this.letters, 400);
                            this.scaleDownText();
                        }, 2100));            
                    } else {
                        G288Components.bigWin.totalReached.addOnce(this.onAmountReached);
                    }                         
                    this.resolveIn();            
                });
            }, 200));  
        });
    }

    

    public skipIn() {
        soundManager.customEvent("big_win");
        G288Components.bigWin.totalReached.removeAll();
        this.clearTimers();
        this.cleanLetterTweens();
        this.cleanTextTween();
        RevolverWinTransitions.winValue.visible = true;
        RevolverWinTransitions.winValue.scale.set(1, 1);        
        RevolverWinTransitions.winValue.visible = true;     
        RevolverWinTransitions.glowContainer.scale.set(1, 1);
        RevolverWinTransitions.coins.emit = true;
        RevolverWinTransitions.winGlow.visible = true;
        RevolverWinTransitions.winGlow.alpha = 0.8;
        for(let i = 0; i < this.letters.length; i++) {
            TweenJS.removeAll(this.letters[i]);
            this.letters[i].scale.set(1, 1);
            this.letters[i].visible = true;
        }
        this.resolveIn();
    }

    public out(): Contract<void> {  
        return sequence([
            () => Contract.wrap(() => {      
                this.clearTimers();
                this.cleanLetterTweens();
                this.cleanTextTween();
                TweenJS.removeAll(RevolverWinTransitions.glowContainer.scale);
                TweenJS.removeAll(RevolverWinTransitions.winValue.scale);               
                const totalWin = gameState.getCurrentGame().totalCreditsWon;
                Components.betBar.winnings.setWinnings(totalWin, totalWin, 750); 
                FadeOut(RevolverWinTransitions.winGlow, 500).execute();
                this.zoomOutLetters(this.letters, 400);
                this.zoomOut(RevolverWinTransitions.winValue, 400).then(() => RevolverWinTransitions.winValue.visible = false);
                RevolverWinTransitions.coins.emit = false;
                soundManager.customEvent("plaque_exit");
            }), 
            () => this.zoomOutStacks(),
            () => Contract.wrap(() => {
                soundManager.customEvent("celebration_end");
            }),
            () => FadeOut(RevolverWinTransitions.background, this.BOUNCE_TIME),
            () => Contract.wrap(() => this.clean()),
            () => Contract.getTimeoutContract(750)            
        ]);
    }

    public destroy() {
        this.clearTimers();

        super.destroy();
    }

    private onAmountReached = () => {
        this.emphasizeText(1.3, 1.1, 1.2);
        new TweenJS.Tween(RevolverWinTransitions.glowContainer.scale)
        .to({x: 1.1, y: 1.1}, 200)
        .start();
    }

}


// WEBPACK FOOTER //
// ./~/ifdef-loader/ifdef-loader.js??ref--0-1!./src/transitions/big-win-transitions.ts